/** @jsx isolateComponent */

import { formatDateTime } from '@zapier/date';
import { Alert, AlertDescription, Link } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

import { invoices_account_invoices as PendingInvoice } from '@zapier/payment/src/types';

const PendingPaymentWarningBar = (props: {
  pendingInvoice: PendingInvoice;
}) => (
  <Alert type="warning">
    <AlertDescription>
      Hi there! Your{' '}
      <strong>
        {formatDateTime(props.pendingInvoice.createdAt, 'default')}
      </strong>{' '}
      <Link href="/help/account/billing-pricing/why-my-payment-pending-and-why-cant-i-change-my-plan">
        payment is still pending
      </Link>
      . Please check back later to make plan changes.
    </AlertDescription>
  </Alert>
);

export default PendingPaymentWarningBar;
